"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioMark = RadioMark;
exports.CheckboxMark = CheckboxMark;
exports.CheckboxLabel = CheckboxLabel;
var jsx_runtime_1 = require("react/jsx-runtime");
// ================================================================
// v2/components/SelectionControls/index.tsx
// Figma: Checkbox コンポーネント (type=Radio / type=Checkbox)。
//
// RadioMark    — 20px の円。未選択は border neutral.hint、
//                選択時は border primary.main + 内側 12px のドット。
// CheckboxMark — 16px の角丸 2px。未選択は border neutral.hint、
//                選択時は塗り primary.main + 白いチェック。
// CheckboxLabel— CheckboxMark + ラベルを横に並べた押下可能な行。
//
// いずれも「見た目」のみを担い、状態は呼び出し側が持つ。
// フォーム要素としての a11y は role/aria をここで付与する。
//
// 色は theme.palette.v2 (useV2Palette) から取得する。
// ================================================================
var material_1 = require("@mui/material");
var theme_1 = require("../../theme");
var tokens_1 = require("../../tokens");
var Icons_1 = require("../Icons");
function RadioMark(_a) {
    var checked = _a.checked, _b = _a.disabled, disabled = _b === void 0 ? false : _b;
    var p = (0, theme_1.useV2Palette)();
    var borderColor = disabled
        ? p.foreground.neutral.disabled
        : checked
            ? p.foreground.primary.main
            : p.foreground.neutral.hint;
    return (
    // Figma: Checkbox 本体は 4px のパディングを持つ
    (0, jsx_runtime_1.jsx)(material_1.Box, { sx: { p: "".concat(tokens_1.spacing.xs, "px"), display: 'flex', flexShrink: 0 }, children: (0, jsx_runtime_1.jsx)(material_1.Box, { sx: {
                boxSizing: 'border-box',
                width: 20,
                height: 20,
                borderRadius: "".concat(tokens_1.radius.full, "px"),
                border: "1px solid ".concat(borderColor),
                backgroundColor: checked ? p.foreground.neutral.white : 'transparent',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }, children: checked && ((0, jsx_runtime_1.jsx)(material_1.Box, { sx: {
                    width: 12,
                    height: 12,
                    borderRadius: "".concat(tokens_1.radius.full, "px"),
                    backgroundColor: disabled
                        ? p.foreground.neutral.disabled
                        : p.foreground.primary.main,
                } })) }) }));
}
function CheckboxMark(_a) {
    var checked = _a.checked, _b = _a.disabled, disabled = _b === void 0 ? false : _b;
    var p = (0, theme_1.useV2Palette)();
    var accent = disabled
        ? p.foreground.neutral.disabled
        : p.foreground.primary.main;
    return (
    // Figma: Checkbox/Small は 2px のパディングを持つ
    (0, jsx_runtime_1.jsx)(material_1.Box, { sx: { p: '2px', display: 'flex', flexShrink: 0 }, children: (0, jsx_runtime_1.jsx)(material_1.Box, { sx: {
                boxSizing: 'border-box',
                width: 16,
                height: 16,
                borderRadius: "".concat(tokens_1.radius.xxs, "px"),
                border: "1px solid ".concat(checked ? accent : p.foreground.neutral.hint),
                backgroundColor: checked ? accent : 'transparent',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }, children: checked && ((0, jsx_runtime_1.jsx)(Icons_1.CheckIcon, { sx: { fontSize: 12, color: p.foreground.neutral.white } })) }) }));
}
/** CheckboxMark + ラベルを横に並べた押下可能な行 (Figma: Checkbox label)。 */
function CheckboxLabel(_a) {
    var checked = _a.checked, onChange = _a.onChange, label = _a.label, _b = _a.disabled, disabled = _b === void 0 ? false : _b;
    var p = (0, theme_1.useV2Palette)();
    return ((0, jsx_runtime_1.jsxs)(material_1.Stack, { component: material_1.ButtonBase, direction: "row", alignItems: "center", spacing: "".concat(tokens_1.spacing.xs, "px"), role: "checkbox", "aria-checked": checked, "aria-disabled": disabled, disabled: disabled, onClick: function (event) {
            return !disabled && onChange(!checked, event);
        }, sx: {
            alignSelf: 'center',
            cursor: disabled ? 'default' : 'pointer',
        }, children: [(0, jsx_runtime_1.jsx)(CheckboxMark, { checked: checked, disabled: disabled }), (0, jsx_runtime_1.jsx)(material_1.Typography, { component: "span", sx: __assign(__assign({}, tokens_1.textStyles.body), { lineHeight: "".concat(tokens_1.lineHeight.sm, "px"), color: disabled
                        ? p.foreground.neutral.disabled
                        : p.foreground.neutral.primary, textAlign: 'left' }), children: label })] }));
}
